(function ocrDefinition() {
    'use strict';
    angular.module('Entities')
        .service('ocrProcessService', [
            'restUrlBuilder', function ocrProcessService(restUrlBuilder) {

                this.getStatus = function getStatus() {
                    return restUrlBuilder.all('ocr/Status').get();
                };

                this.removeOcrTask = function removeOcrTask() {
                    return restUrlBuilder.all('ocr/Stop').get();
                };

                this.addOcrTask = function addOcrTask() {
                    return restUrlBuilder.all('ocr/Start').get();
                };
                this.runOcrTask = function addOcrTask() {
                    return restUrlBuilder.all('ocr/Execute').get();
                };
            }
        ]);
})();